import React from 'react'

const CompletedIcon = () => {
  return (
    <>
    <svg width="22" height="22" viewBox="0 0 22 22">
        <g id="Group_199" data-name="Group 199" transform="translate(-1 -1)">
          <path
            id="Path_2511"
            data-name="Path 2511"
            d="M12,2.5a9.5,9.5,0,0,0,0,19A.75.75,0,1,1,12,23,11,11,0,1,1,23,12a.75.75,0,0,1-1.5,0A9.5,9.5,0,0,0,12,2.5"
            fill="#fff"
          />
          <path
            id="Path_2512"
            data-name="Path 2512"
            d="M13.759,17.48l3.728,3.314a.308.308,0,0,0,.513-.23V18h4.25a.75.75,0,0,0,0-1.5H18V13.936a.308.308,0,0,0-.513-.23L13.759,17.02a.307.307,0,0,0,0,.46m3.521-8.2a.75.75,0,0,0-1.06-1.06l-5.97,5.969L7.78,11.72a.75.75,0,1,0-1.06,1.06l3,3a.75.75,0,0,0,1.06,0Z"
            fill="#fff"
          />
        </g>
      </svg>
    </>
  )
}

export default CompletedIcon